export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./backpack-btn.vue?vue&type=template&id=40b70621&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/header/school-test/components/backpack-btn.vue?vue&type=template&id=40b70621&
// module id = 1304
// module chunks = 0